import { Component, OnInit } from '@angular/core';
import { ModalController, NavController } from '@ionic/angular';
import { NavigationService } from 'src/app/services/navigation.service';
import { UtilserviceService } from 'src/app/services/utilservice.service';

@Component({
  selector: 'app-payment-modal',
  templateUrl: './payment-modal.page.html',
  styleUrls: ['./payment-modal.page.scss'],
})
export class PaymentModalPage implements OnInit {

  constructor(
    private modal:ModalController,
    private navCtrl:NavController,
    private util:UtilserviceService,
    private nav: NavigationService
  ) { }

  home(){
    this.modal.dismiss();
    this.nav.appointment();
    
  }
  ngOnInit() {
    // console.log();
  }

}
